import type { QueryClient, QueryKey } from "@tanstack/react-query";

export function trimInfiniteQuery(
  queryClient: QueryClient,
  queryKey: QueryKey,
) {
  queryClient.setQueryData(queryKey, (data: any) => {
    if (!data?.pages?.length) return data;

    return {
      pages: [data.pages[0]],
      pageParams: [data.pageParams[0]],
    };
  });
}
